import { createContext } from 'react';
import { AddClientCommand, EditMailingPermitCommand, EditOrganizationCommand, OrgLogoCommandDto, Organization } from '../api/models/schema';

interface OrganizationContextProps {
  organization: Organization | undefined;
  errorMessage:string;
  isLoading:boolean;
  updateOrganization: (orgCommand: EditOrganizationCommand) => void;
  updateMailingPermit: (orgCommand: EditMailingPermitCommand) => void;
  addClient: (orgCommand:AddClientCommand) => void;
  updateLogo: (logoCommand: OrgLogoCommandDto) => void;
}

export const OrganizationContext = createContext<OrganizationContextProps>({
  organization: undefined,
  updateOrganization: () => {},
  updateMailingPermit: () => {},
  addClient: () => {},
  updateLogo: () => {},
  errorMessage:'',
  isLoading:false
});